import script from "./AppSwiper.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSwiper.vue?vue&type=script&setup=true&lang=js"

import "./AppSwiper.vue?vue&type=style&index=0&id=475ed3b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-475ed3b2"]])

export default __exports__